import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { EmptyStateStack } from "@/components/empty-state/EmptyState";
import { ItemAttributesSkeleton } from "./ItemAttributesSkeleton";
export function ItemAttributesEmptyState(t0) {
  const $ = _c(6);
  const {
    cta
  } = t0;
  const t = useTranslations("ItemAttributesEmptyState");
  let t1;
  if ($[0] !== t) {
    t1 = t("noAttributes");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ItemAttributesSkeleton overrides={{
      Skeleton: {
        className: "animate-none"
      }
    }} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cta || $[4] !== t1) {
    t3 = <EmptyStateStack className="h-[256px]" cta={cta} description={t1} showImageStack={false}>{t2}</EmptyStateStack>;
    $[3] = cta;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}